import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { fantasy } from '@sorare/core/src/lib/glossary';

import { TacticPreview_footballRivalsLineup } from './__generated__/index.graphql';

const Icon = styled.img`
  width: var(--double-unit);
  height: var(--double-unit);
  object-fit: contain;
`;

type Props = { lineup: TacticPreview_footballRivalsLineup | null };
export const TacticPreview = ({ lineup }: Props) => {
  if (!lineup) return null;

  const { tacticScore, tactic } = lineup;
  return (
    <SBHorizontal>
      <Horizontal gap={0.5}>
        <Icon src={tactic.iconUrl} />
        <LabelS>{tactic.displayName}</LabelS>
      </Horizontal>
      <LabelS bold color="var(--c-score-high)">
        <FormattedMessage
          {...fantasy.pointsWithoutFormat}
          values={{
            score: (
              <FormattedNumber
                value={tacticScore}
                maximumFractionDigits={0}
                signDisplay="exceptZero"
              />
            ),
          }}
        />
      </LabelS>
    </SBHorizontal>
  );
};

TacticPreview.fragments = {
  footballRivalsLineup: gql`
    fragment TacticPreview_footballRivalsLineup on FootballRivalsLineup {
      id
      tacticScore
      tactic {
        slug
        iconUrl
        displayName
      }
    }
  ` as TypedDocumentNode<TacticPreview_footballRivalsLineup>,
};
